import { ConsoleFormatter, DefaultLoggerManagerBuilder, LogLevel } from "@betomorrow/logging-core";

import { Config } from "../config/config";

const loggingEnabled = Config.LOGGING_ENABLED;

// Disabling the logs used to mean building a manager with no appender at all, so even errors
// went nowhere: during the COS enrollment incident the app recorded nothing, on any device.
// Keep the console appender in both cases and let the level decide what gets through.
export const loggerManager = loggingEnabled
  ? new DefaultLoggerManagerBuilder().withLevel(LogLevel.DEBUG).withConsoleAppender(new ConsoleFormatter()).build()
  : new DefaultLoggerManagerBuilder().withLevel(LogLevel.ERROR).withConsoleAppender(new ConsoleFormatter()).build();

export const logger = loggerManager.getLogger();
